import { Col } from 'react-bootstrap'
import styled from 'styled-components'

export const TicketSectionContainer = styled(Col)`
    display: flex;
    justify-content: flex-start;
    padding-right: 0;
    padding-left: 0;
    align-items: stretch;
    width: 100%;
    @media only screen and (min-width: 810px) {
        justify-content: center;
    }
`
